

angular.module('messageOfTheDay.module', [])
  .directive('messageOfTheDay', function () {
    return {
      templateUrl: '/app-ds3/dashboard/widgets/messageOfTheDay/messageOfTheDay.partial.html',
      bindToController: true,
      controller: 'MessageOfTheDayController',
      controllerAs: 'vm'
      // No link function needed here; controller handles logic.
    };
  })
  .controller('MessageOfTheDayController', [
    '$scope', '$sce', '$http', '$q', 'ipCookie', 'MESSAGE_OF_THE_DAY',  'motdService',
    function ($scope, $sce, $http, $q, ipCookie, MESSAGE_OF_THE_DAY, motdService) {
      var vm = this;
      var motdRequestCanceler = $q.defer();

      // const MESSAGE_OF_THE_DAY = configService.messageOfTheDay();
      
      // Public API for the template
      vm.visible = false;
      vm.dismiss = dismiss;
      vm.acknowledged = acknowledged;
      vm.toTrustedHtml = toTrustedHtml;

      // When the view content is ready, decide whether to show the MotD.
      //$scope.$on('$viewContentLoaded',

      vm.$onInit = function () {
        init();
      };


      function init() {
        // Exit early if the feature flag is off.
        if (!MESSAGE_OF_THE_DAY || !MESSAGE_OF_THE_DAY.enabled) return;

        // Fetch the current MotD.
        motdService.getLatest({ timeout: motdRequestCanceler.promise })
          .then(function (motd) {
            // If nothing to show or server marks it disabled, keep hidden.
            if (!motd || motd.enabled === false) return;

            // Make the fetched message available to the view
            vm.id = motd.id;
            vm.type = motd.type;                 // e.g., 'success', 'info', etc.
            vm.date = motd.date;                 // ISO date string recommended
            vm.heading = motd.heading;
            vm.description = motd.description;   // plain text or trusted HTML (see toTrustedHtml)
            vm.callToAction = motd.callToAction;
            vm.link = motd.link;
            vm.linkText = motd.linkText;

            // Cookie logic: if the stored id is different, it's a new message → show it.
            var dismissedId = ipCookie('messageOfTheDay');
            if (dismissedId !== vm.id) {
              // Clear any stale cookie and show
              ipCookie.remove('messageOfTheDay', { path: '/' });
              vm.visible = true;
            } else {
              // Already acknowledged → keep hidden
              vm.visible = false;
            }
          }).catch(function (err) {
            if (err.status === 503 && err.data?.type === "MOTD_API") {
              console.error('Service has been disabled in configuration');
            }
            else {
              console.error('Failed to fetch Message of the Day', err);
            }
          });
      }
      // });

      // --- Methods ---

      // Hide without storing an acknowledgement (temporary close)
      function dismiss() {
        vm.visible = false;
      }

      // Hide and remember the current message id (acknowledged)
      function acknowledged() {
        vm.visible = false;
        if (vm.id) {
          // Long expiry and explicit path so the cookie is available app-wide
          ipCookie('messageOfTheDay', vm.id, { expires: 365, path: '/' });
        }
      }

      // If description is trusted HTML from your API, use this in the template:
      // <div ng-bind-html="vm.toTrustedHtml(vm.description)"></div>
      // If it's plain text with \n, just bind and use CSS white-space: pre-wrap
      function toTrustedHtml(html) {
        return $sce.trustAsHtml(html || '');
      }

      $scope.$on('$destroy', function () {
        motdRequestCanceler.resolve();
      });
    }
  ])
  .service('motdService', ['$http', function MotdService($http) {
    /**
     * Get the latest server-chosen Message of the Day.
     * Adjust URL to your API (e.g., /api/notices/motd).
     */
    this.getLatest = function (options) {
      var requestConfig = options && options.timeout ? { timeout: options.timeout } : undefined;

      return $http.get('/api/messageoftheday/current', requestConfig)
        .then(
          function (res) {
            return res.data;
          },
          function (err) {
            return Promise.reject(err);
          }
        )

    };

    // /**
    //  * Get a specific MotD by id.
    //  */
    // this.getById = function (id) {
    //   return $http.get('/api/notices/' + encodeURIComponent(id))
    //     .then(function (res) { return res.data; });
    // };

  }]);






// angular.module('messageOfTheDay.module', [])
//   .directive('messageOfTheDay', [
//     function () {
//       return {
//         templateUrl: '/app-ds3/dashboard/widgets/messageOfTheDay/messageOfTheDay.partial.html',
//         bindToController: true,
//         controller: 'MessageOfTheDayController',
//         controllerAs: 'message',
//         link: function () {

//         }
//       }
//     }
//   ])
//   .controller('MessageOfTheDayController', ['$scope', 'ipCookie', 'MESSAGE_OF_THE_DAY',
//     function ($scope, ipCookie, MESSAGE_OF_THE_DAY_CONFIG_TOKEN) {
//       var message = this;


//       message.dismiss = function () {
//         //// Close the messagebox and store the fact that this message
//         //// has been aknowledged in local storage
//         ////   ipCookie("ie9warning", true);
//         message.visible = false;
//         //ipCookie("messageOfTheDay", message.id);
//       };

//       message.acknowledged = function () {
//         // Close the messagebox and store the fact that this message
//         // has been aknowledged in local storage
//         // Give the cookie a long expiry (default for this library is days
//         // or it will expire art the end of the session
//         message.visible = false;
//         ipCookie("messageOfTheDay", message.id, { expires: 100000 });
//       };

//       $scope.$on('$viewContentLoaded', function () {
//         // find out if there is a message to display, determine whether the user
//         // has already dismissed it, and if not, display it.
//         if (MESSAGE_OF_THE_DAY_CONFIG_TOKEN.enabled) {


//           if (ipCookie("messageOfTheDay") != message.id) {
//             // if the new id dies not match the existing cookie, there is a new message.
//             // therefore, kill the existing cookie and make the message visible
//             ipCookie.remove("messageOfTheDay");
//             message.visible = true;
//           }
//         }
//       });



//       $scope.$on('$viewContentLoaded', function () {
//         if (!MESSAGE_OF_THE_DAY_CONFIG_TOKEN.enabled) return;

//         motdService.getLatest().then(function (motd) {
//           if (!motd || motd.enabled === false) return;

//           var dismissedId = ipCookie('messageOfTheDay');
//           $scope.message = motd;

//           if (dismissedId !== motd.id) {
//             ipCookie.remove('messageOfTheDay');
//             $scope.message.visible = true;
//           } else {
//             $scope.message.visible = false;
//           }
//         }).catch(function (err) {
//           console.error('Failed to load MotD', err);
//         });
//       });

//       $scope.toTrustedHtml = function (html) {
//         return $sce.trustAsHtml(html || '');
//       };

//       $scope.dismissMotd = function () {
//         if ($scope.message && $scope.message.id) {
//           ipCookie('messageOfTheDay', $scope.message.id, { expires: 30, path: '/' });
//         }
//         if ($scope.message) $scope.message.visible = false;
//       };

//     }
//   ]);

